import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d1f1f92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-[100vh]" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-black h-[10%]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col h-full justify-center items-center" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl" }, "🧹 Ménages")
  ])
], -1))
const _hoisted_3 = { class: "px-4 h-[40%]" }
const _hoisted_4 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-black h-[10%]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col h-full justify-center items-center" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl" }, "💰 Paiements")
  ])
], -1))
const _hoisted_6 = { class: "px-4 h-[40%]" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Ajouter un paiement")
const _hoisted_8 = {
  key: 0,
  class: "text-green-400 font-bold text-center my-4"
}
const _hoisted_9 = { class: "px-4 mb-4 border-t border-black" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-8 text-center text-2xl" }, " Liste ", -1))
const _hoisted_11 = {
  key: 0,
  id: "menages"
}
const _hoisted_12 = { class: "text-center py-2 bg-neutral-700 px-2 rounded text-white" }
const _hoisted_13 = { class: "text-2xl capitalize" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Total : ")
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Paiements : ")
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = {
  key: 0,
  class: "menage bg-neutral-200 px-2 py-1 rounded"
}
const _hoisted_19 = { class: "text-center font-bold text-xl py-2" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("De ")
const _hoisted_21 = { class: "font-bold" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" à ")
const _hoisted_23 = { class: "font-bold" }
const _hoisted_24 = { class: "menage bg-slate-300 px-2 py-1 rounded" }
const _hoisted_25 = { class: "text-center font-bold text-xl py-2" }
const _hoisted_26 = { class: "py-8 text-center text-xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JbButton = _resolveComponent("JbButton")!
  const _component_JbMainContainer = _resolveComponent("JbMainContainer")!

  return (_openBlock(), _createBlock(_component_JbMainContainer, {
    p: "0",
    bg: "bg-white"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_JbButton, {
            display: "inline-block",
            w: "w-full",
            p: "py-20",
            text: "text-white",
            class: "text-xl font-bold transition-all duration-400",
            bg: _ctx.statusQR === false ? 'bg-green-600' : 'bg-red-600',
            onClick: _ctx.toggleMenage
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_ctx.statusQR === true ? "Terminer le ménage en cours" : "Commencer un ménage"), 1),
              (_ctx.statusQR === true && Object.keys(_ctx.openMenage).length !== 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.displayDuration(_ctx.openMenage)), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["bg", "onClick"])
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paiementInput) = $event)),
              class: "w-full text-center bg-neutral-200 text-4xl rounded py-6 mb-4"
            }, null, 512), [
              [_vModelText, _ctx.paiementInput]
            ]),
            _createVNode(_component_JbButton, {
              display: "inline-block",
              w: "w-full",
              p: "py-6",
              text: "text-white",
              class: "font-bold transition-all duration-400",
              bg: "bg-blue-600",
              onClick: _ctx.addPaiement
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.paiementShow)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " ✅ Paiement ajouté "))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        (_ctx.menagesQR)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventsByMonth, (monthCollection) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "mb-12 space-y-2",
                  key: monthCollection
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(new Date(monthCollection.yearIndex, monthCollection.monthIndex).toLocaleString('default', { month: 'long', year: 'numeric' })), 1),
                    _createElementVNode("p", null, [
                      _hoisted_14,
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.dateDiffToString(_ctx.computeTotalMenagesTime(monthCollection.menages))), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _hoisted_16,
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.sortedPaiements[monthCollection.yearIndex+'-'+monthCollection.monthIndex] ? _ctx.computeTotalPaiements(_ctx.sortedPaiements[monthCollection.yearIndex+'-'+monthCollection.monthIndex].paiements)+' €' : '0 €'), 1)
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthCollection.menages, (menage) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: menage.id
                    }, [
                      (menage.attributes.closed_at !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.dateobjToDisplay(new Date(menage.attributes.createdAt))), 1),
                            _createElementVNode("span", null, [
                              _hoisted_20,
                              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.displayTime(menage.attributes.createdAt)), 1),
                              _hoisted_22,
                              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.displayTime(menage.attributes.closed_at)), 1)
                            ]),
                            _createElementVNode("div", null, " Durée : " + _toDisplayString(Math.round((new Date(menage.attributes.closed_at) - new Date(menage.attributes.createdAt))/(1000 * 60))) + " minutes", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthCollection.paiements, (paiement) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: paiement.id
                    }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.dateobjToDisplay(new Date(paiement.attributes.date))), 1),
                        _createElementVNode("div", null, "Montant : " + _toDisplayString(paiement.attributes.amount) + " €", 1)
                      ])
                    ]))
                  }), 128))
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("p", null, "Total d'heures : " + _toDisplayString(_ctx.totalMenagesTime), 1),
                _createElementVNode("p", null, "Total de paiements : " + _toDisplayString(_ctx.totalPaiements) + " €", 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}